import { Record } from "immutable";
import moment from "moment";

const defaults = {
    created_at_ms: undefined,
    id: undefined,
    name: "",
    items_ref: undefined,
    root_ref: undefined,
    item_display_preferences_ref: undefined,
    brand_collection_properties: undefined,
    // snapshot: undefined,
};

interface IBrandCollectionProperties {
    brand_id: string;
    brand_name: string;
}

export class Collection extends Record(defaults) {
    declare created_at_ms: moment.Moment;
    declare id: string;
    declare name: string;
    declare items_ref: any;
    declare root_ref: any;
    declare item_display_preferences_ref: any;
    declare brand_collection_properties?: IBrandCollectionProperties;

    constructor(args) {
        super({
            ...args,
            created_at_ms: moment.utc(parseInt(args.created_at_ms, 10)),
        });
    }
}
